<label
  ><input
    type="checkbox"
    [indeterminate]="filterState === states.Crossed"
    [ngModel]="isChecked()"
    (ngModelChange)="onToggle($event)"
  />
  {{ getLabel() }}
</label>
